import { FEEDBACK_SUBMIT_REQUEST, FEEDBACK_SUBMIT_SUCCESS, FEEDBACK_SUBMIT_FAILURE, FEEDBACK_RESET } from '../types';

const initialState = {
  submitting: false,
  submitted: false,
  error: '',
  response: null,
};

export default function feedback(state = initialState, action) {
  switch (action.type) {
    case FEEDBACK_SUBMIT_REQUEST:
      return { ...state, submitting: true, submitted: false, error: '', response: null };
    case FEEDBACK_SUBMIT_SUCCESS:
      return { ...state, submitting: false, submitted: true, error: '', response: action.payload };
    case FEEDBACK_SUBMIT_FAILURE:
      return { ...state, submitting: false, submitted: false, error: action.error };
    case FEEDBACK_RESET:
      return { ...initialState };
    default:
      return state;
  }
}
